import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Loader } from 'src/shared/components/loader';
export const ContentFormLoader = ({ isRedirectingToNewContentForm }) => {
    const { t } = useTranslation();
    return (_jsxs("div", { className: "flex h-full flex-col items-center justify-center", children: [_jsx(Loader, { "data-testid": "content-form-loader" }), isRedirectingToNewContentForm && (_jsx("p", { className: "mt-4 text-medium text-neutral-700", children: t('content.wait_to_create_other_content') }))] }));
};
